'use client';

import { SiteLayout } from '@/components/SiteLayout/SiteLayout';
import { CartProvider } from '@/context/cart';
import { ToastProvider } from '@/components/Toast/Toast';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ToastProvider>
      <CartProvider>
        <SiteLayout>{children}</SiteLayout>
      </CartProvider>
    </ToastProvider>
  );
}
